import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Checkbox, Label, Selector } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import Model from "./ItemModel.js";
import S from './ItemTypeEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.detail.item.OptionsEditor');
const DISPLAY_OPTIONS = [{
  value: null,
  get name() {
    return t('default');
  }
}, {
  value: 'block',
  get name() {
    return t('block');
  }
}, {
  value: 'inline',
  get name() {
    return t('inline');
  }
}, {
  value: 'inline-block',
  get name() {
    return t('inline-block');
  }
}];
function OptionsEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  if (value == null) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: S.grid,
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "input",
      children: t('display')
    }), /*#__PURE__*/_jsx(Selector, {
      variant: "dataTablePopup",
      eventData: "setDisplay",
      value: Model.getDisplay(value),
      values: DISPLAY_OPTIONS,
      onChange: onModelChange
    }), /*#__PURE__*/_jsx(Checkbox, {
      label: t('editable'),
      value: Model.getEditable(value),
      eventData: "setEditable",
      onChange: onModelChange
    })]
  });
}
export default OptionsEditor;